export const environment = {
  production: true,
  appEnv: 'dev',
  cognito: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_JDUX7dvIV',
    userPoolWebClientId: '2ft64nn6a8j1cpfe666bs4tl77',
  },
  notificationsEndpoint: 'https://rllsdux3i5aqvkygz4wmi24kdm.appsync-api.us-east-2.amazonaws.com/graphql',
  coreApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/core',
  operationsApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/operations',
  sourcingApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sourcing',
  salesApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sales',
  productApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/product',
  warehouseApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/warehouse',
  financialsApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/financials',
  mailingApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/mailing',
  sourcingTarifario: 'https://sourcingdev.explorandes.app/tarifario',
  cognitoDomain: 'https://explorandes.auth.us-east-2.amazoncognito.com',
  isLocal: false,

};
